/**
 * CartSettingsContainer
 * --
 */
import React from 'react';
import CartSettingsPresenter from './CartSettingsPresenter';
import { useGetSetting, useUpdateSetting } from 'hooks/SettingHooks';
import MessageAlert from 'utils';

const CartSettingsContainer = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== Mutate ===== */
  const { updateSetting } = useUpdateSetting();

  /* ===== Data ===== */
  const { data: CartSetting } = useGetSetting(1, null, {
    select: (res) => {
      const { status, data } = res;

      if (status !== 200) return null;

      return data.cart_setting;
    },
    initialData: null,
  });

  /* ===== STATE ===== */
  const [setting, setSetting] = React.useState({
    max_save_date: 7,
  });
  const [isLoading, setIsLoading] = React.useState(false);

  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /**
   * 데이터 바인딩
   * --
   * @param {string} t
   * @param {string} v
   */
  const handleChange = (t, v) => {
    setSetting((prev) => ({
      ...prev,
      [t]: v,
    }));
  };

  /**
   * 장바구니 설정 변경
   * --
   */
  const handleSubmit = async () => {
    const confirm = window.confirm('장바구니 설정을 변경하시겠습니까?');

    if (!confirm) return;

    try {
      setIsLoading(true);

      const { status, data } = await updateSetting({
        setting_id: 1,
        cart_setting: setting,
      });

      if (status !== 200) {
        MessageAlert.info('설정 변경에 실패하였습니다.');
        return;
      }

      MessageAlert.success('설정이 변경되었습니다.');
      setSetting(data?.cart_setting);
    } catch (err) {
      console.error('[handleSubmit] Error!! ', err);
      MessageAlert.error('설정 변경에 실패하였습니다.');
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      }, 1000);
    }
  };

  /* ===== HOOKS ===== */
  React.useEffect(() => {
    if (!CartSetting) return;

    setSetting(CartSetting);
  }, [CartSetting]);

  /* ===== RENDER ===== */
  return (
    <>
      <CartSettingsPresenter
        setting={setting}
        origin={CartSetting}
        isLoading={isLoading}
        onChange={handleChange}
        onSubmit={handleSubmit}
      />
    </>
  );
};

export default CartSettingsContainer;
